import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class TaxReferenceService extends BaseReferenceService {
  constructor() {
    super('TaxReference');
  }
}
